import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import App from './app';
import LoginLayout from './loginapp';
import LogoutLayout from './logoutapp';
import RegisterLayout from './registerapp';

import Welcome from './layouts/welcome/index';
import Dashboard from './layouts/dashboard/index';
import Helps from './layouts/helps/index';

import Goals from './layouts/goals/index';
import GoalEdit from './layouts/goals/edit';
import GoalCreate from './layouts/goals/create';

import Objectives from './layouts/objectives/index';
import ObjectivesEdit from './layouts/objectives/edit';
import ObjectivesCreate from './layouts/objectives/create';

import Strategies from './layouts/strategies/index';
import StrategiesEdit from './layouts/strategies/edit';
import StrategiesCreate from './layouts/strategies/create';

import Lines from './layouts/lines/index';
import LinesEdit from './layouts/lines/edit';
import LinesCreate from './layouts/lines/create';

import Axis from './layouts/axis/index';
import AxisEdit from './layouts/axis/edit';
import AxisCreate from './layouts/axis/create';

import Activities from './layouts/activities/index';
import ActivityEdit from './layouts/activities/edit';
import ActivityCreate from './layouts/activities/create';

import Concepts from './layouts/concepts/index';
import ConceptEdit from './layouts/concepts/edit';
import ConceptCreate from './layouts/concepts/create';

import Profile from './layouts/profile/index';

import Versions from './layouts/versions/index';
import VersionEdit from './layouts/versions/edit';
import VersionCreate from './layouts/versions/create';
import VersionPhasesGroups from './layouts/versions/version_groups_phases';

import Phases from './layouts/phases/index';
import PhaseEdit from './layouts/phases/edit';
import PhaseCreate from './layouts/phases/create';
import GroupsPhases from './layouts/group_phases/index';
import GroupPhaseEdit from './layouts/group_phases/edit';
import GroupPhaseCreate from './layouts/group_phases/create';

import Permissions from './layouts/permissions/index';
import PermissionEdit from './layouts/permissions/edit';
import PermissionCreate from './layouts/permissions/create';

import Roles from './layouts/roles/index';
import RolesEdit from './layouts/roles/edit';
import RolesCreate from './layouts/roles/create';

import Users from './layouts/users/index';
import UserEdit from './layouts/users/edit';
import UserCreate from './layouts/users/create';

import Projects from './layouts/projects/index';
import ProjectEdit from './layouts/projects/project';
import ProjectGoalsEdit from './layouts/projects/goals';
import ProjectExpensesEditForm from './layouts/projects/expenses';
import ProjectCommissions from './layouts/projects/commissions';
import ProjectPhasesEditForm from './layouts/projects/phases';
import ProjectEmployeesEditForm from './layouts/projects/employees';
import ProjectFolios from './layouts/projects/folios';

import ProjectOwner from './layouts/project/owner';
import ProjectAgency from './layouts/project/instance';
import ProjectGoal from './layouts/project/registry';
import ProjectGoalCreate from './layouts/project/goals/create';
import ProjectGoalEdit from './layouts/project/goals/edit';
import Profiles from './layouts/project/profiles';
import ProjectExpenses from './layouts/project/expenses';
import ProjectConclusion from "./layouts/project/conclusion";

import RevisionProject from "./layouts/revision/project";
import RevisionLegal from './layouts/revision/legal';
import RevisionAgreements from './layouts/revision/agreements';
import RevisionReportsFinancial from './layouts/revision/reports_financial';
import RevisionReportsExpenses from './layouts/revision/reports_expenses';
import RevisionReportsSummary from './layouts/revision/reports_summary';

import Entities from './layouts/entities/index';
import EntityEdit from './layouts/entities/edit';
import EntityCreate from './layouts/entities/create';

import Municipalities from './layouts/municipalities/index';
import MunicipalityEdit from './layouts/municipalities/edit';
import MunicipalityCreate from './layouts/municipalities/create';

import Agencies from './layouts/agencies/index';
import AgenciesEdit from './layouts/agencies/edit';
import AgenciesCreate from './layouts/agencies/create';

import AmountsAgencies from './layouts/amounts_agencies/index';
import AmountsAgenciesEdit from './layouts/amounts_agencies/edit';
import AmountsAgenciesCreate from './layouts/amounts_agencies/create';

import Notifications from './layouts/notifications/index';
import NotificationsEdit from './layouts/notifications/edit';
import NotificationsCreate from './layouts/notifications/create';
import NotificationMessages from './layouts/notifications/messages';

import CommissionValidation from './layouts/revision/commission';

import ReportRevisions from './layouts/reports/revisions';
import ReportsFinancial from './layouts/reports/financial';
import ReportExpenses from './layouts/reports/expenses';
import ReportPeopleHired from './layouts/reports/employees';
import ReportSurveys from './layouts/reports/surveys';
import ReportSummary from './layouts/reports/summary';

import Surveys from './layouts/surveys/index';
import SurveysCreate from './layouts/surveys/create';
import SurveysEdit from './layouts/surveys/edit';

import Agreements from './layouts/tracing/agreements';
import Dispersions from './layouts/tracing/dispersions';

import CdmEmployees from './layouts/cdms/employees';

import {sessionService} from "redux-react-session";

/* RUTAS CDMS */
import CdmHome from "./cdm-frontend/pages/index";
import CdmDetail from "./cdm-frontend/pages/detail";
import CdmPlacesDirectory from "./cdm-frontend/pages/substantial/directory-places";
import CdmServicesDirectory from "./cdm-frontend/pages/substantial/directory-services";
import CdmActivitiesCalendar from "./cdm-frontend/pages/substantial/calendar-activities";
import CdmZonesDirectory from "./cdm-frontend/pages/substantial/directory-zones";
import CdmInfrastructureDirectory from "./cdm-frontend/pages/substantial/directory-infrastructure";

/* RUTAS Acervo */
import Acervo from "./acervo/containers/Home/Home";
import AcervoDetail from "./acervo/containers/Detail/Detail";

import NotFound from "./layouts/notfound";
import CdmPlanning from "./cdm-frontend/pages/support/planning";
import CdmPlanningEdit from "./cdm-frontend/pages/support/planning/edit";
import PersonsDirectory from "./cdm-frontend/pages/directory";
import PersonsDirectoryEdit from "./cdm-frontend/pages/directory/edit";

export default (
	<Route key="app" component={App}>
		<Switch>
			<Route key="login" path="/" exact component={(props => (<LoginLayout {...props} />))} />
			<Route key="logout" path="/logout" exact component={(props => (<LogoutLayout {...props} />))} />
			<Route key="register" path="/registro" exact component={(props => (<RegisterLayout {...props} />))} />
			<Route key="dashboard" path="/dashboard" exact component={(props) => (<Dashboard {...props} />)} />
			<Route key="welcome" path="/inicio" exact component={(props) => (<Welcome {...props} />)} />
			<Route key="profile" path="/perfil" onEnter={sessionService.checkAuth} exact component={(props) => (<Profile {...props} />)} />
			<Route key="helps" path="/ayuda" exact component={(props) => (<Helps {...props}/>)} />

			<Route key="proigualdad-goals" path="/proigualdad/metas" exact component={(props) => (<Goals {...props} />)} />
			<Route key="proigualdad-goals-edit" path="/proigualdad/metas/editar/:id" exact component={(props) => (<GoalEdit {...props} />)} />
			<Route key="proigualdad-goals-create" path="/proigualdad/metas/crear" exact component={(props) => (<GoalCreate {...props} />)} />

			<Route key="proigualdad-objectives" path="/proigualdad/objetivos" exact component={(props) => (<Objectives {...props} />)} />
			<Route key="proigualdad-objectives-edit" path="/proigualdad/objetivos/editar/:id" exact component={(props) => (<ObjectivesEdit {...props} />)} />
			<Route key="proigualdad-objectives-create" path="/proigualdad/objetivos/crear" exact component={(props) => (<ObjectivesCreate {...props} />)} />

			<Route key="proigualdad-strategies" path="/proigualdad/estrategias" exact component={(props) => (<Strategies {...props} />)} />
			<Route key="proigualdad-strategies-edit" path="/proigualdad/estrategias/editar/:id" exact component={(props) => (<StrategiesEdit {...props} />)} />
			<Route key="proigualdad-strategies-create" path="/proigualdad/estrategias/crear" exact component={(props) => (<StrategiesCreate {...props} />)} />

			<Route key="proigualdad-lines" path="/proigualdad/lineas" exact component={(props) => (<Lines {...props} />)} />
			<Route key="proigualdad-lines-edit" path="/proigualdad/lineas/editar/:id" exact component={(props) => (<LinesEdit {...props} />)} />
			<Route key="proigualdad-lines-create" path="/proigualdad/lineas/crear" exact component={(props) => (<LinesCreate {...props} />)} />

			<Route key="proigualdad-axis" path="/proigualdad/ejes" exact component={(props) => (<Axis {...props} />)} />
			<Route key="proigualdad-axis-edit" path="/proigualdad/ejes/editar/:id" exact component={(props) => (<AxisEdit {...props} />)} />
			<Route key="proigualdad-axis-create" path="/proigualdad/ejes/crear" exact component={(props) => (<AxisCreate {...props} />)} />

			<Route key="proigualdad-activities" path="/proigualdad/actividades" exact component={(props) => (<Activities {...props} />)}/>
			<Route key="proigualdad-activities-Edit" path="/proigualdad/actividades/editar/:id" exact component={(props) => (<ActivityEdit {...props} />)}/>
			<Route key="proigualdad-activities-create" path="/proigualdad/actividades/crear" exact component={(props) => (<ActivityCreate {...props} />)}/>

			<Route key="concepts" path="/gastos/conceptos" exact component={(props) => (<Concepts {...props}/>)} />
			<Route key="concept-edit" path="/gastos/conceptos/editar/:id" exact component={(props) => (<ConceptEdit {...props}/>)}/>
			<Route key="concept-create" path="/gastos/conceptos/crear" exact component={(props) => (<ConceptCreate {...props}/>)}/>

			<Route key="versions" path="/versiones" exact component={(props) => (<Versions {...props} />)}/>
			<Route key="version-edit" path="/versiones/editar/:year" exact component={(props) => (<VersionEdit {...props} />)}/>
			<Route key="version-create" path="/versiones/crear" exact component={(props) => (<VersionCreate {...props} />)}/>
			<Route key="version-groups-phases" path="/versiones/editar/:year/grupo/:id" exact component={(props) => (<VersionPhasesGroups {...props} />)}/>

			<Route key="phases" path="/fases" exact component={(props) => (<Phases {...props} />)}/>
			<Route key="phases-edit" path="/fases/editar/:id" exact component={(props) => (<PhaseEdit {...props} />)}/>
			<Route key="phases-create" path="/fases/crear" exact component={(props) => (<PhaseCreate {...props} />)}/>
			<Route key="groups-phases" path="/fases/grupos" exact component={(props) => (<GroupsPhases {...props}/>)}/>
			<Route key="groups-phases-edit" path="/fases/grupos/editar/:id" exact component={(props) => (<GroupPhaseEdit {...props}/>)}/>
			<Route key="groups-phases-create" path="/fases/grupos/crear" exact component={(props) => (<GroupPhaseCreate {...props}/>)}/>

			<Route key="permissions" path="/permisos" exact component={(props) => (<Permissions {...props} />)}/>
			<Route key="permissions-edit" path="/permisos/editar/:id" exact component={(props) => (<PermissionEdit {...props} />)}/>
			<Route key="permissions-create" path="/permisos/crear" exact component={(props) => (<PermissionCreate {...props} />)}/>

			<Route key="roles" path="/perfiles" exact component={(props) => (<Roles {...props} />)}/>
			<Route key="roles-edit" path="/perfiles/editar/:id" exact component={(props) => (<RolesEdit {...props} />)}/>
			<Route key="roles-create" path="/perfiles/crear" exact component={(props) => (<RolesCreate {...props} />)}/>

			<Route key="users" path="/usuarios" exact component={(props) => (<Users {...props} />)}/>
			<Route key="users-edit" path="/usuarios/editar/:id" exact component={(props) => (<UserEdit {...props} />)}/>
			<Route key="users-create" path="/usuarios/crear" exact component={(props) => (<UserCreate {...props} />)}/>

			<Route key="projects" path="/proyectos" exact component={(props) => (<Projects {...props} />)} />
			<Route key="projects-edit" path="/proyectos/editar/datos/:id" exact component={(props) => (<ProjectEdit {...props} />)}/>
			<Route key="projects-goals-edit" path="/proyectos/editar/metas/:id" exact component={(props) => (<ProjectGoalsEdit {...props} />)}/>
			<Route key="projects-expenses-edit" path="/proyectos/editar/gastos/:id" exact component={(props) => (<ProjectExpensesEditForm {...props} />)}/>
			<Route key="projects-commissions" path="/proyectos/editar/encuesta-comisiones/:id" exact component={(props) => (<ProjectCommissions {...props} />)}/>
			<Route key="projects-phases-groups-edit" path="/proyectos/editar/procesos/:id" exact component={(props) => (<ProjectPhasesEditForm {...props} />)}/>
			<Route key="projects-employees-edit" path="/proyectos/editar/personal/:id" exact component={(props) => (<ProjectEmployeesEditForm {...props} />)}/>
			<Route key="projects-folios" path="/proyectos/folios/:modality" exact component={(props) => (<ProjectFolios {...props}/>)}/>

			<Route key="project-owner" path="/proyecto/:modality/titular/:state?/:municipality?" exact component={(props) => (<ProjectOwner {...props}/>)}/>
			<Route key="project-agency" path="/proyecto/:modality/instancia/:state?/:municipality?" exact component={(props) => (<ProjectAgency {...props}/>)}/>
			<Route key="project-goals" path="/proyecto/:modality/metas/:state?/:municipality?" exact component={(props) => (<ProjectGoal {...props}/>)}/>
			<Route key="project-goal-create" path="/proyecto/:modality/proigualdad-meta/crear/:state?/:municipality?" exact component={(props) => (<ProjectGoalCreate {...props}/>)}/>
			<Route key="project-goal-edit" path="/proyecto/:modality/proigualdad-meta/editar/:goal?/:state?/:municipality?" exact component={(props) => (<ProjectGoalEdit {...props}/>)}/>
			<Route key="project-expenses" path="/proyecto/:modality/gastos/:state?/:municipality?" exact component={(props) => (<ProjectExpenses {...props}/>)}/>
			<Route key="project-profiles" path="/proyecto/:modality/adicionales/:state?/:municipality?" exact component={(props) => <Profiles {...props} />} />
			<Route key="project-conclusion" path="/proyecto/:modality/conclusion/:state?/:municipality?" exact component={(props) => <ProjectConclusion {...props} />} />

			<Route key="entities" path="/entidades" exact component={(props) => (<Entities {...props}/>)}/>
			<Route key="entities-edit" path="/entidades/editar/:id" exact component={(props) => (<EntityEdit {...props}/>)}/>
			<Route key="entities-create" path="/entidades/crear" exact component={(props) => (<EntityCreate {...props}/>)}/>

			<Route key="municipalities" path="/municipios" exact component={(props) => (<Municipalities {...props}/>)}/>
			<Route key="municipalities-edit" path="/municipios/editar/:id" exact component={(props) => (<MunicipalityEdit {...props}/>)}/>
			<Route key="municipalities-create" path="/municipios/crear" exact component={(props) => (<MunicipalityCreate {...props}/>)}/>

			<Route key="agencies" path="/instancias" exact component={(props) => (<Agencies {...props}/>)}/>
			<Route key="agencies-edit" path="/instancias/editar/:id" exact component={(props) => (<AgenciesEdit {...props}/>)}/>
			<Route key="agencies-create" path="/instancias/crear" exact component={(props) => (<AgenciesCreate {...props}/>)}/>

			<Route key="amounts-agencies" path="/instancias/montos" exact component={(props) => (<AmountsAgencies {...props}/>)}/>
			<Route key="amounts-agencies-edit" path="/instancias/montos/editar/:id" exact component={(props) => (<AmountsAgenciesEdit {...props}/>)}/>
			<Route key="amounts-agencies-create" path="/instancias/montos/crear" exact component={(props) => (<AmountsAgenciesCreate {...props}/>)}/>

			<Route key="revision-project" path="/revision/:modality/proyecto/:state?/:municipality?" exact component={(props) => (<RevisionProject {...props}/>)}/>
			<Route key="revision-legal" path="/revision/:modality/juridica/:state?/:municipality?" exact component={(props) => (<RevisionLegal {...props}/>)}/>
			<Route key="revision-commission" path="/revision/comisiones" exact component={(props) => (<CommissionValidation {...props}/>)}/>
			<Route key="revision-agreements" path="/revision/:modality/convenios/:type/:state?/:municipality?" exact component={(props) => (<RevisionAgreements {...props}/>)}/>
			<Route key="revision-reports-financial" path="/revision/:modality/avance-fisico-financiero/:state?/:municipality?" exact component={(props) => (<RevisionReportsFinancial {...props}/>)}/>
			<Route key="revision-reports-expenses" path="/revision/:modality/gastos-coordinacion/:state?/:municipality?" exact component={(props) => (<RevisionReportsExpenses {...props}/>)}/>
			<Route key="revision-reports-summary" path="/revision/:modality/resumen/:state?/:municipality?" exact component={(props) => (<RevisionReportsSummary {...props}/>)}/>

			<Route key="notifications" path="/notificaciones" exact component={(props) => (<Notifications {...props}/>)}/>
			<Route key="notifications-edit" path="/notificaciones/editar/:id" exact component={(props) => (<NotificationsEdit {...props}/>)}/>
			<Route key="notifications-create" path="/notificaciones/crear" exact component={(props) => (<NotificationsCreate {...props}/>)}/>
			<Route key="notification-messages" path="/notificacion/:modality" exact component={(props) => (<NotificationMessages {...props}/>)}/>

			<Route key="report-revisions" path="/reporte/:modality/revisiones/:state?/:municipality?" exact component={(props) => (<ReportRevisions {...props}/>)}/>

			<Route key="surveys" path="/encuestas" exact component={(props) => (<Surveys {...props}/>)}/>
			<Route key="surveys-create" path="/encuestas/crear" exact component={(props) => (<SurveysCreate {...props}/>)}/>
			<Route key="surveys-edit" path="/encuestas/editar/:id" exact component={(props) => (<SurveysEdit {...props}/>)}/>

			<Route key="agreements" path="/seguimiento/:modality/convenios/:state?/:municipality?" exact component={(props) => (<Agreements {...props}/>)}/>
			<Route key="dispersions" path="/seguimiento/:modality/dispersion/:state?/:municipality?" exact component={(props) => (<Dispersions {...props}/>)}/>

			<Route key="report-financial" path="/informes/:modality/avance-fisico-financiero/:state?/:municipality?" exact component={(props) => (<ReportsFinancial {...props}/>)}/>
			<Route key="report-expenses" path="/informes/:modality/gastos-coordinacion/:state?/:municipality?" exact component={(props) => (<ReportExpenses {...props}/>)}/>
			<Route key="report-people-hired" path="/informes/:modality/personas-contratadas/:state?/:municipality?" exact component={(props) => (<ReportPeopleHired {...props}/>)}/>
			<Route key="report-surveys" path="/informes/:modality/encuesta-calidad/:state?/:municipality?" exact component={(props) => (<ReportSurveys {...props}/>)}/>
			<Route key="report-summary" path="/informes/:modality/resumen/:state?/:municipality?" exact component={(props) => (<ReportSummary {...props}/>)}/>

			<Route key="cdm-employees" path="/cdms/personal/:state/:municipality?" exact component={(props) => (<CdmEmployees {...props}/>)}/>


			<Route key="cdm-home" path="/cdm/inicio" exact component={(props) => <CdmHome {...props} />} />
			<Route key="cdm-places-directory" path="/cdm/tarea/:id/places-directory/:step" exact component={(props) => <CdmPlacesDirectory {...props} />} />
			<Route key="cdm-services-directory" path="/cdm/tarea/:id/services-directory/:step" exact component={(props) => <CdmServicesDirectory {...props} />} />
			<Route key="cdm-activities-directory" path="/cdm/tarea/:id/activities-calendar/:step" exact component={(props) => <CdmActivitiesCalendar {...props} />} />
			<Route key="cdm-map-area" path="/cdm/tarea/:id/map-area/:step" exact component={(props) => <CdmZonesDirectory {...props} />} />
			<Route key="cdm-infrastructure-directory" path="/cdm/tarea/:id/infrastructure-directory/:step" exact component={(props) => <CdmInfrastructureDirectory {...props} />} />
			<Route key="cdm-detail" path="/cdm/tarea/:id" exact component={(props) => <CdmDetail {...props} />} />
			<Route key="cdm-planning-home" path="/cdm/planeacion" exact component={(props) => <CdmPlanning {...props} />} />
			<Route key="cdm-planning-edit" path="/cdm/planeacion/editar/:id" exact component={(props) => <CdmPlanningEdit {...props} />} />
			<Route key="cdm-directory-users" path="/cdm/directorio/personas" exact component={(props) => <PersonsDirectory {...props} />} />
			<Route key="cdm-directory-users-edit" path="/cdm/directorio/personas/editar/:id" exact component={(props) => <PersonsDirectoryEdit {...props} />} />

			<Route key="acervo-home" path="/acervo" exact component={(props) => <Acervo {...props} />} />
			<Route key="acervo-detail" path="/acervo/proyectos/:id" exact component={(props) => <AcervoDetail {...props} />} />

			<Route key="not-found" component={() => <NotFound />} />
		</Switch>
	</Route>
);



// WEBPACK FOOTER //
// ./src/routes.js